var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:'product-history-list',attrs:{"screenConfig":_vm.setScreenConfig,"persistenceKey":_vm.persistenceKey,"gcPopupCustomerProductHistoryDtlConfig":_vm.gcPopupCustomerProductHistoryDtlConfig,"setLoading":_vm.setLoading,"loadDataGrid":_vm.loaded,"rowClick":_vm.rowClickCallBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }